import { Grid, Typography } from "@mui/material";
import AppButton from "../../components/appButton/appButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import { colors } from "../../app/theme/colors";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import MySitePhotoRequest from "../../models/mySite/mySitePhotoModel";
import { useAppDispatch } from "../../app/redux/hooks";
import { saveMySitePhoto } from "../../slices/mySiteSlice";

interface Props {
  selectedPhoto: MySitePhotoRequest[] | null;
  isOpenUploadImgModal: boolean;
  clickedCube: string;
  cubeType: string; 
  selectedItems: any;
}

export default function MySiteImgSection({
  selectedPhoto,
  isOpenUploadImgModal,
  clickedCube,
  cubeType,
  selectedItems
}: Props) {
const dispatch = useAppDispatch();
  const handleSave = () => {
    if(selectedPhoto){
      dispatch(saveMySitePhoto(selectedPhoto))

    }
  }
  return (
    <>
      <Grid
        container
        display={"flex"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        mt={1}
        padding={"10px"}
      >
        {selectedPhoto && (
          <>
            <Grid
              item
              md={12}
              justifyContent={"flex-start"}
              alignItems={"center"}
              display={"flex"}
            >
              <Grid item>
                <AddAPhotoIcon sx={{ color: "rgba(75, 138, 244, 0.8)" }} />
              </Grid>
              <Grid item>
                <Typography variant="body2" sx={{ marginLeft: "5px" }}>
                  Fotografija
                </Typography>
              </Grid>
            </Grid>
            {!isOpenUploadImgModal && (
              <>
                <Grid
                  item
                  md={12}
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {selectedPhoto && (
                    <>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        style={{ textAlign: "left" }}
                      >
                        <img
                          src={
                            selectedPhoto.find(
                              (photo) =>
                                photo.orderNumber ===
                                selectedItems[cubeType]?.orderNumber
                            )?.base64Photo || ""
                          }
                          alt="uploaded"
                          style={{ maxWidth: "100%", maxHeight: "100%" }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ textAlign: "right" }}
                        display={"flex"}
                        justifyContent={"flex-end"}
                        mt={1}
                      >
                        <Grid item mr={1}>
                          <AppButton
                            startIcon={<EditIcon />}
                            label={"Izmeni"}
                            color={"rgba(140, 140, 140, 1)"}
                            hover={"rgba(210, 226, 252, 1)"}
                          />
                        </Grid>

                        <AppButton
                          startIcon={<CheckCircleOutlineIcon />}
                          label={"Sacuvaj"}
                          color={colors.green}
                          hover={colors.green}
                          onClick={handleSave}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}
          </>
        )}
      </Grid>
    </>
  );
}
